module.exports = __webpack_public_path__ + "img/cnd_Upload.23156f90.svg";